module.exports = __webpack_public_path__ + "img/EXV_Weinflaschen_Icons_Perl-Schaumweine.b5d7afbb.svg";